import { createContext, useContext, useState } from "react";

const QuotationContext = createContext();

export function QuotationProvider({ children }) {
  const [quotations, setQuotations] = useState([
    {
      id: 1,
      vendorId: 1,
      vendorName: "Sharma Dairy",
      item: "Milk",
      price: 5000,
      gst: 5,
      deliveryDays: 2,
      status: "Pending",
    },
    {
      id: 2,
      vendorId: 2,
      vendorName: "Aggarwal Traders",
      item: "Sugar",
      price: 4800,
      gst: 5,
      deliveryDays: 4,
      status: "Finalized",
    },
  ]);

  const addQuotation = (quote) => {
    setQuotations((prev) => [...prev, { ...quote, id: Date.now() }]);
  };

  const finalizeQuotation = (id) => {
    setQuotations((prev) =>
      prev.map((q) =>
        q.id === id ? { ...q, status: "Finalized" } : q
      )
    );
  };

  return (
    <QuotationContext.Provider
      value={{ quotations, addQuotation, finalizeQuotation }}
    >
      {children}
    </QuotationContext.Provider>
  );
}

export const useQuotations = () => useContext(QuotationContext);
